import { toast } from 'react-toastify';

export const ShowSuccessToast = (message) => {
  toast.success(message, {
    position: 'top-right',
    autoClose: 3000,
  });
};

export const ShowDangerToast = (message) => {
  toast.error(message, {
    position: 'top-right',
    autoClose: 3000,
  });
};